module.exports = __webpack_public_path__ + "static/media/nike-ksa-what-if-you-can.3c0486f2.jpg";